<template>
<v-container fluid >
    <v-card class="ma-3 pa-3 align-top" elevation="11" light color="secondary">
        <v-card-title class="justify-center"><h2 class="textTitle--text">{{ $t('chooseclient.screenTitle') }}</h2></v-card-title>
        <div><v-select
            :items="clients"
            :item-text="'name'"
            return-object
            v-model="selectedclient"
            :label="$t('chooseclient.selectLabel')"
            class="ma-3 font-weight-black"
            solo
            @change="$emit('changeclient', selectedclient)"
            ></v-select>
    </div>
    <v-card-actions class="justify-center align-center">
      <v-btn small @click="formNewclient_visible = true" class="pa-3 success font-weight-black" outlined>{{ $t('chooseclient.createButton') }}</v-btn>
      <v-btn small @click="selectedclient_visible = !selectedclient_visible" class="pa-3 info font-weight-black" outlined>{{ $t('chooseclient.details') }}</v-btn>
    </v-card-actions>
    </v-card>

    


    <v-card 
            elevation="12"
            v-if="selectedclient_visible"
            class="ma-3"
            light
            color="secondary">
              <v-card-title class="subheading  justify-center"><h1 class="textTitle--text">{{ selectedclient.name }}</h1></v-card-title>

              <v-divider class="ma-3"></v-divider>

              <v-row
              class="mb-12 justify-center"
              no-gutters
              >
                 
                      <v-list dense class="ma-3 tertiary" width="90%">
                <v-list-item>
                  <v-list-item-content class="font-weight-bold text--text">{{ $t('chooseclient.clientCode') }}<v-chip label class="ma-1 pa-1 quaterny">{{ selectedclient.id }}</v-chip></v-list-item-content>
                  
                </v-list-item>
                 <v-list-item>
                  <v-list-item-content class="font-weight-bold text--text">{{ $t('chooseclient.dpi') }}<v-chip label class="ma-1 pa-1 quaterny">{{ selectedclient.dpi }}</v-chip></v-list-item-content>
                  
                </v-list-item>
                <v-list-item>
                  <v-list-item-content class="font-weight-bold text--text">{{ $t('chooseclient.clientType') }}<v-chip label class="ma-1 pa-1 quaterny">{{ selectedclient.type }}</v-chip></v-list-item-content>
                  
                </v-list-item>
                <v-list-item>
                  <v-list-item-content class="font-weight-bold text--text">{{ $t('chooseclient.visitRate') }}<v-chip label class="ma-1 pa-1 quaterny">{{ selectedclient.visit_frequence }}</v-chip></v-list-item-content>
                  
                </v-list-item>
              
                <v-list-item>
                  <v-list-item-content class="font-weight-bold text--text">{{ $t('chooseclient.clientTel') }}<v-chip label class="ma-1 pa-1 quaterny">{{ selectedclient.tel }}</v-chip></v-list-item-content>
                  
                </v-list-item>
                <v-list-item>
                  <v-list-item-content class="font-weight-bold text--text">{{ $t('chooseclient.clientTotalBuy') }}<v-chip label class="ma-1 pa-1 quaterny">{{ selectedclient.total_compra }}</v-chip></v-list-item-content>
                  
                </v-list-item>
                <v-list-item>
                  <v-list-item-content class="font-weight-bold text--text">{{ $t('chooseclient.clientQtyBuy') }}<v-chip label class="ma-1 pa-1 quaterny">{{ selectedclient.compras.length }}</v-chip></v-list-item-content>
                  
                </v-list-item>
              </v-list>
                 
              </v-row>
                         
            </v-card>

            

      <v-dialog
              v-model="formNewclient_visible"
              max-width="80%"
              :retain-focus="false"
            >
            <v-card flat class="pa-5 secondary">
            <v-card  class="pa-3 primary">
<v-card-title class="headline font-weight-bold textTitle--text justify-center">{{ $t('chooseclient.newClientButton') }}</v-card-title>

              <v-row class="justify-center align-center">
                <h2 class="mx-5 textMenu--text">{{ $t('chooseclient.clientName') }}</h2>
                <v-text-field
      v-model="name"
      class="font-weight-black text-h4 ma-2 pa-2 shrink text-center"
      background-color="quinty"
      height="75px"
      rounded
    ></v-text-field>
              </v-row>
              <v-row class="justify-center align-center">
                <h2 class="mx-5 textMenu--text">{{ $t('chooseclient.dpi') }}</h2>
                <v-text-field
      v-model="dpi"
      class="font-weight-black text-h4 ma-2 pa-2 shrink text-center"
      background-color="quinty"
      height="75px"
      rounded
    ></v-text-field>
              </v-row>
              <v-row class="justify-center align-center">
                <h2 class="mx-5 textMenu--text">{{ $t('chooseclient.clientTel') }}</h2>
               <v-text-field
      v-model="tel"
      type="number"
      class="font-weight-black text-h4 ma-2 pa-2 shrink  "
      background-color="quinty"
      height="60px"
      rounded
    ></v-text-field>
              </v-row>
              
              <v-row class="justify-center align-center">
                <h2 class="mx-5 textMenu--text">{{ $t('chooseclient.clientType') }}</h2>
               <v-select
      v-model="tipo"
      :items="types"
      rounded
      class="font-weight-black text-h6 ma-2 pa-2 shrink  "
      background-color="quinty"
      height="60px"
    ></v-select>
              </v-row>
    
    
    
    <v-card-actions class="justify-center align-center ma-3 pa-3">
    <v-btn large class="ma-4 pa-3 success font-weight-black black--text" @click="save_client">{{ $t('save') }}</v-btn>
    <v-btn large class="ma-4 pa-3 error font-weight-black black--text" @click="formNewclient_visible=false">{{ $t('close') }}</v-btn>
  </v-card-actions>
            </v-card>
            </v-card>
              
  </v-dialog>

</v-container>
</template>

<script>
          
          import {mapActions} from 'vuex'
import {mapGetters} from 'vuex'

export default {
    data () {
        return {
            name:'',
            tipo:'',
            dpi:'',
            tel:'',
            formNewclient_visible:false,
            selectedclient_visible:false,
            selectedclient:{},
            
      

        }

    },
    computed:{
      types(){
      var types= [
        this.$t('clientTypes.type1'),
        this.$t('clientTypes.type2'),
        this.$t('clientTypes.type3'),
        ]
        return types
        },
      headers(){
        var headers = [
        {
          text: this.$t('headers.clientBuyId'),
          align: 'start',
          sortable: false,
          value: 'idcompras',
        },
        { text: this.$t('headers.clientBuyDate'), value: 'fecha' },
        { text: this.$t('headers.clientBuyTotal'), value: 'ammount' },
      ]
      return headers
      },
      
        ...mapGetters({
        clients:'clientDb',
      })
        
    },
    methods:{
      ...mapActions([
        'addClient'
      ]),
        save_client (){
          var id = 'client1';
            var clientdb = this.$store.state.clients;        

            if(clientdb.length>0){
               
            var size = clientdb.length
            var pos=1

            for(var i=1;i<size;i++){
              if(clientdb[i].id!=id){continue}else{
                pos+=1
                id='cat'+pos
                i=0
              }
            }
            }
            var client = {
              "id":id,
              "name":this.name,
              "tel":this.tel,
              "type":this.tipo,
              "visit_frequence":0,
              "total_compra":0,
              "compras":[],
              "dpi":this.dpi
            }

         this.addClient(client)
        this.clear_form_newclient();
        this.formNewclient_visible=false;        
      },
        choose_client (value) {
          
          const result = this.clients.find( ({ id }) => id === value );
          
          //var id = value;
            this.selectedclient=result;
            this.selectedclient_visible=true;
        },
        clear_form_newclient(){
            this.name = '';
            this.tel = '';
            this.tipo = '';
        }

    }
}
</script>